/* Blosoma: autoplay muted looping videos only while they are on screen. */
(function () {
  var vids = document.querySelectorAll('video.bl-autoplay, .bl-autoplay video');
  if (!vids.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  vids.forEach(function (v) {
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    v.removeAttribute('controls');
  });
  if (reduce) { vids.forEach(function (v) { v.pause(); }); return; }
  if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
    });
  }, { threshold: 0.15 });
  vids.forEach(function (v) { io.observe(v); });
})();
